// import { useState } from 'react'

// import { QueryClient, QueryClientProvider } from 'react-query'

// const MINUTE = 60 * 1000

// const getQueryClient = () => {
//   const options = {
//     defaultOptions: {
//       queries: {
//         staleTime: 1 * MINUTE,
//         retry: 0,
//       },
//     },
//   }

//   return new QueryClient(options)
// }

// const QueryProvider = ({ children }) => {
//   const [queryClient] = useState(() => getQueryClient())

//   return (
//     <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
//   )
// }

// export default QueryProvider

import { ReactNode, useState } from 'react'

import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const QueryProvider = ({ children }: { children: ReactNode }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error, query) => {
            if (query.meta?.operation) {
              ;(error as any).operation = query.meta?.operation
            }
          },
        }),
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}

export default QueryProvider
